export const bursaNews = [
  {
    id: 1,
    title: "Bursa'da Yeni Ulaşım Ağı Projesi Onaylandı",
    summary: "Büyükşehir Belediyesi, şehrin doğu-batı aksını birbirine bağlayacak yeni metro hattı projesini resmi olarak onayladı. 2026 sonunda tamamlanması hedeflenen proje 12 istasyon içerecek.",
    category: "Ulaşım",
    date: "31 Mart 2026",
    image: "https://public.readdy.ai/ai/img_res/912abd1c359a3eb864bd9f83535c2fbd.jpg",
    source: "Bursa Büyükşehir Belediyesi",
  },
  {
    id: 2,
    title: "Uludağ'da Sezon Rekoru: 500 Bin Ziyaretçi",
    summary: "Bu kış sezonu Uludağ, rekor sayıda ziyaretçiyle kapandı. Yoğun kar yağışı sayesinde pistlerin uzun süre açık kalması turizm gelirlerine büyük katkı sağladı.",
    category: "Turizm",
    date: "30 Mart 2026",
    image: "https://readdy.ai/api/search-image?query=snowy%20mountain%20ski%20resort%20with%20skiers%20on%20slopes%2C%20aerial%20view%20of%20beautiful%20winter%20landscape%2C%20Bursa%20Uludag%20Turkey%2C%20panoramic%20vista%2C%20pristine%20white%20snow&width=400&height=250&seq=news2&orientation=landscape",
    source: "Bursa Turizm Dergisi",
  },
  {
    id: 3,
    title: "Osmangazi Kültür Merkezi Kapılarını Açıyor",
    summary: "3 yıl süren inşaat süreci tamamlanan Osmangazi Kültür ve Sanat Merkezi nisan ayı başında açılıyor. Konser salonu, sergi alanları ve kütüphane gibi mekanları barındıracak.",
    category: "Kültür",
    date: "29 Mart 2026",
    image: "https://readdy.ai/api/search-image?query=modern%20cultural%20arts%20center%20building%20exterior%20with%20glass%20facade%20and%20clean%20minimalist%20architecture%2C%20evening%20lighting%2C%20city%20background%2C%20contemporary%20design%2C%20warm%20tones&width=400&height=250&seq=news3&orientation=landscape",
    source: "Osmangazi Belediyesi",
  },
  {
    id: 4,
    title: "Bursa'da Çiftçilere Destekleme Ödemeleri Başladı",
    summary: "Tarım Bakanlığı aracılığıyla Bursa'daki çiftçilere 2026 yılı ilk çeyrek destekleme ödemeleri banka hesaplarına aktarılmaya başlandı.",
    category: "Ekonomi",
    date: "28 Mart 2026",
    image: "https://readdy.ai/api/search-image?query=lush%20green%20farm%20fields%20in%20Bursa%20Turkey%20countryside%2C%20agricultural%20landscape%20with%20olive%20trees%20and%20vegetables%2C%20sunny%20day%20golden%20hour%2C%20fertile%20land&width=400&height=250&seq=news4&orientation=landscape",
    source: "Bursa Tarım Müdürlüğü",
  },
  {
    id: 5,
    title: "Bursaspor Alt Yapısından 3 İsim Milli Takıma Davet Edildi",
    summary: "U21 Milli Takım teknik direktörü, Bursaspor altyapısından yetişen 3 genç oyuncuyu Nisan kampına davet etti. Bu davet kulübün gençlik yatırımlarının meyvelerini verdiğini gösteriyor.",
    category: "Spor",
    date: "27 Mart 2026",
    image: "https://readdy.ai/api/search-image?query=young%20football%20players%20training%20on%20a%20green%20pitch%2C%20sunny%20day%2C%20green%20and%20white%20jerseys%2C%20dynamic%20action%20shot%2C%20stadium%20background%2C%20sports%20photography&width=400&height=250&seq=news5&orientation=landscape",
    source: "TFF Haber Merkezi",
  },
  {
    id: 6,
    title: "Tarihi Kapalıçarşı Restore Edildi, Ziyaretçilere Açıldı",
    summary: "18 ay süren kapsamlı restorasyon çalışmalarının ardından Bursa Tarihi Kapalıçarşı, geleneksel mimarisi korunarak modern dokunuşlarla yeniden ziyaretçilere açıldı.",
    category: "Tarih",
    date: "26 Mart 2026",
    image: "https://readdy.ai/api/search-image?query=historic%20Ottoman%20bazaar%20interior%20with%20beautifully%20restored%20stone%20arches%20and%20domed%20ceiling%2C%20warm%20lantern%20lights%2C%20traditional%20Turkish%20marketplace%2C%20rich%20cultural%20heritage%2C%20vibrant%20colors&width=400&height=250&seq=news6&orientation=landscape",
    source: "Kültür Bakanlığı",
  },
];
